module.exports = __webpack_public_path__ + "static/media/40-3.61ddc5c2.mp3";